import { useContext } from 'react';
import { PostHogContext } from '@/providers/PostHogProvider';

/**
 * Custom hook to access PostHog instance throughout the app
 * 
 * @returns PostHog instance and initialization status
 * 
 * @example
 * const { posthog, isInitialized } = usePostHog();
 * 
 * if (isInitialized) {
 *   posthog?.capture('button_clicked', { button_name: 'CTA' });
 * }
 */
export function usePostHog() {
  const context = useContext(PostHogContext);
  
  if (!context) {
    throw new Error('usePostHog must be used within PostHogProvider');
  }
  
  return context;
}
